import React, { createContext, FC, useState, useContext, useMemo, useCallback } from 'react';
export interface AppState {
  attendeeName: string;
  setAppState: (newState: Omit<Partial<AppState>, 'setAppState'>) => void;
  showFooter: boolean;
  showHeader: boolean;
  receivedOneWayMessage: boolean;
  arrivedViaDeeplink: boolean;
  documentTitle: string;
  showReportIssueLightbox: boolean;
}

export const AppStateContext = createContext<AppState | null>(null);

const AppStateProvider: FC<WithChildren> = ({ children }) => {
  const initialState: Omit<AppState, 'setAppState'> = {
    attendeeName: '',
    showFooter: true,
    showHeader: true,
    receivedOneWayMessage: false,
    arrivedViaDeeplink: false,
    documentTitle: '',
    showReportIssueLightbox: false,
  };
  const [appState, setState] = useState<Omit<AppState, 'setAppState'>>(initialState);

  const setAppState = useCallback((newState: Omit<Partial<AppState>, 'setAppState'>) => {
    setState((state) => ({ ...state, ...newState }));
  }, []);

  const value = useMemo(
    () => ({
      setAppState,
      ...appState,
    }),
    [appState, setAppState]
  );

  return <AppStateContext.Provider value={value}>{children}</AppStateContext.Provider>;
};

export const useAppState = (): AppState => {
  const state = useContext(AppStateContext);

  if (!state) {
    throw new Error('useAppState must be used within a AppStateProvider');
  }

  return state;
};

export default AppStateProvider;
